// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"352":"50c99f91","803":"9c2df9c3"}[chunkId] + ".css";
};